import { LEGAL } from "../lib/site";

export const LEGAL_PAGES = {
  "privacy": {
    metaTitle: "Informativa sulla Privacy | Appartamenti in Val di Sole",
    title: "Informativa sulla Privacy",
    description: "Informativa sul trattamento dei dati personali di Appartamenti in Val di Sole ai sensi del Regolamento UE 2016/679 (GDPR).",
    sections: [
      {
        h2: "1. Titolare del trattamento",
        p: [
          `Il Titolare del trattamento dei dati è ${LEGAL.company} (${LEGAL.vat}), con sede in ${LEGAL.address}.`,
          `Per qualsiasi richiesta relativa alla privacy puoi contattarci via email a ${LEGAL.email} o al numero ${LEGAL.phone}.`,
        ],
      },
      {
        h2: "2. Quali dati raccogliamo",
        p: ["Trattiamo i seguenti dati personali:"],
        list: [
          "Dati di prenotazione: nome e cognome, email, numero di telefono, date e dettagli del soggiorno.",
          "Dati di pagamento: gestiti direttamente e in modo sicuro dai provider Stripe e PayPal (non conserviamo i dati completi della carta).",
          "Dati di navigazione e cookie: indirizzo IP, dati statistici anonimi raccolti solo previo consenso.",
          "Contenuti delle richieste inviate tramite l'assistente virtuale o i moduli di contatto.",
        ],
      },
      {
        h2: "3. Finalità e base giuridica",
        p: ["Trattiamo i tuoi dati per:"],
        list: [
          "Gestire prenotazioni, pagamenti e comunicazioni relative al soggiorno (esecuzione del contratto).",
          "Inviare conferme, preventivi e informazioni di accesso via email (esecuzione del contratto).",
          "Adempiere agli obblighi di legge, fiscali e amministrativi (obbligo legale).",
          "Analizzare in forma aggregata l'utilizzo del sito tramite Google Analytics (consenso).",
        ],
      },
      {
        h2: "4. Destinatari dei dati",
        p: ["I dati possono essere comunicati a fornitori che agiscono come responsabili del trattamento, tra cui:"],
        list: [
          "Stripe e PayPal per l'elaborazione dei pagamenti.",
          "Resend per l'invio delle email transazionali.",
          "Smoobu (channel manager) per la gestione delle disponibilità e delle prenotazioni.",
          "Google (Google Analytics) per le statistiche di utilizzo, solo previo consenso.",
        ],
      },
      {
        h2: "5. Conservazione dei dati",
        p: ["Conserviamo i dati per il tempo necessario alle finalità indicate e nel rispetto dei termini di legge (in particolare gli obblighi fiscali e contabili prevedono la conservazione fino a 10 anni)."],
      },
      {
        h2: "6. I tuoi diritti",
        p: ["Ai sensi degli artt. 15-22 del GDPR puoi in ogni momento esercitare i diritti di accesso, rettifica, cancellazione, limitazione, opposizione e portabilità dei dati, oltre a revocare il consenso prestato. Puoi inoltre proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it)."],
        p2: `Per esercitare i tuoi diritti scrivi a ${LEGAL.email}.`,
      },
    ],
  },
  "cookie-policy": {
    metaTitle: "Cookie Policy | Appartamenti in Val di Sole",
    title: "Cookie Policy",
    description: "Informativa estesa sull'uso dei cookie del sito Appartamenti in Val di Sole, in conformità alle linee guida del Garante Privacy.",
    sections: [
      {
        h2: "1. Cosa sono i cookie",
        p: ["I cookie sono piccoli file di testo che i siti salvano sul dispositivo dell'utente per farlo funzionare correttamente o per raccogliere informazioni statistiche. Questo sito utilizza cookie tecnici e, solo con il tuo consenso, cookie statistici."],
      },
      {
        h2: "2. Cookie tecnici (sempre attivi)",
        p: ["Necessari al funzionamento del sito, non richiedono consenso:"],
        list: [
          "Cookie di sessione e preferenze (es. lingua selezionata).",
          "Memorizzazione della scelta sui cookie (cookie_consent_v1).",
          "Token di accesso all'area riservata (solo per gli amministratori).",
        ],
      },
      {
        h2: "3. Cookie statistici (previo consenso)",
        p: ["Utilizziamo Google Analytics 4 (Google Ireland Ltd.) per analizzare in forma aggregata l'utilizzo del sito. Questi cookie vengono attivati SOLO dopo il tuo consenso, grazie a Google Consent Mode v2. In assenza di consenso, il tracciamento resta disattivato."],
        list: [
          "_ga, _ga_* — misurazione delle visite e delle sessioni (durata fino a 24 mesi).",
        ],
      },
      {
        h2: "4. Cookie di marketing (previo consenso)",
        p: ["Utilizziamo il Meta Pixel (Meta Platforms Ireland Ltd.) per misurare l'efficacia delle nostre campagne pubblicitarie su Facebook e Instagram e per mostrare annunci pertinenti. Questi cookie vengono attivati SOLO dopo il tuo consenso; in assenza di consenso il pixel resta in modalità revocata e non traccia."],
        list: [
          "_fbp — identificazione del browser per le campagne Meta (durata fino a 3 mesi).",
        ],
      },
      {
        h2: "5. Come gestire il consenso",
        p: ["Alla prima visita puoi accettare, rifiutare o personalizzare i cookie tramite il banner. Puoi modificare o revocare la tua scelta in qualsiasi momento cliccando l'icona a forma di biscotto (🍪) in basso a sinistra nel sito. Puoi inoltre gestire i cookie dalle impostazioni del tuo browser."],
        p2: `Per informazioni contatta ${LEGAL.email}.`,
      },
    ],
  },
};

export const LEGAL_SLUGS = Object.keys(LEGAL_PAGES);
